import ModalReserva from "ui/pages/Admin/Administracao/Reservas/Listagem/components/ModalReserva";
import { CardReserva } from "ui/pages/Admin/Administracao/Reservas/Listagem/components/ProximasReservas";

import useReservas from "core/features/reservas/hooks/useReservas";
import useTotalDashboard from "core/features/unidades/dashboard/useTotalDashboard";
import CollapsibleListCard from "../CollapsibleListCard";
import { useMemo } from "react";

function CardReservas({
  unidadeId,
  tenantId,
}: {
  unidadeId: string;
  tenantId: string;
}) {
  const { data, isLoading } = useTotalDashboard(
    `/v1/unidades/dashboard/${unidadeId}/total-reservas`
  );

  const NewEntryModal = useMemo(
    () =>
      ({
        isVisible,
        onClose,
        refetch,
      }: {
        isVisible: boolean;
        onClose: () => any;
        refetch?: () => any;
      }) =>
        (
          <ModalReserva
            isOpen={isVisible}
            tenantId={tenantId}
            onClose={onClose}
            onSave={() => refetch?.()}
          />
        ),
    [tenantId]
  );

  return (
    <CollapsibleListCard
      isLoading={isLoading}
      unidadeId={unidadeId}
      value={data?.total ?? 0}
      singularTitleText="reserva de espaço"
      pluralTitleText="reservas de espaço"
      getDataHook={useReservas}
      newEntryButtonText="Nova reserva"
      NewEntryModal={NewEntryModal}
      ContentItem={({ item }) => <CardReserva reserva={item} />}
    />
  );
}

export default CardReservas;
